/**
 * The census-upload-check flag is an object keyed by broker id, the external
 * id or the Salesforce id. bp-api applies the same rule, so the wizard asks
 * for a check exactly when bp-api will give one.
 *
 * An empty object admits every broker, and one listing ids admits only
 * those. Anything else, including the flag being off or missing, admits
 * nobody.
 */
const isAllowlist = (
  value: unknown,
): value is Readonly<Record<string, unknown>> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const admitsBroker = (
  flagValue: unknown,
  brokerIds: readonly string[],
): boolean => {
  if (!isAllowlist(flagValue)) {
    return false;
  }

  const listsNobody = Object.keys(flagValue).length === 0;

  return listsNobody || brokerIds.some((id) => Object.hasOwn(flagValue, id));
};
